import React from 'react';
import { intlShape } from 'react-intl';
import moment from 'moment';

import DobWarningModal from './DobWarningModal';
import PropTypes from '../../propTypes';
import { TranslatedMessage } from 'common/components/Intl';

import * as Fields from './Fields';
import * as m from '../../messages';

class DobFieldGroup extends React.Component {
  static contextTypes = {
    intl: intlShape,
  };

  static propTypes = {
    minRequiredAge: PropTypes.number.isRequired,
    minPurchaseAge: PropTypes.number,
    selectedValues: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    moment.locale(this.context.intl.locale);
    this.localeDateFormat = moment.localeData()._longDateFormat['L'];
    this.state = {
      isModalOpen: false,
      acknowledged: false,
    };
  }

  // Renders date fields in the order specified by locale's long date format
  renderDateFields() {
    const dateFields = {
      m: <Fields.Month />,
      d: <Fields.Day />,
      y: <Fields.Year minRequiredAge={this.props.minRequiredAge} />,
    };

    const separator = format =>
      ['/', '.', '-'].filter(s => format.indexOf(s) > -1);
    const dateFieldKeys = this.localeDateFormat
      .split(separator(this.localeDateFormat))
      .map(component => component.toLowerCase().charAt(0));

    return (
      <div className="DobFieldGroup__fields row">
        {dateFieldKeys.map(key => (
          <div className="col-xs-4" key={key}>
            {dateFields[key]}
          </div>
        ))}
      </div>
    );
  }

  shouldWarn() {
    const { minRequiredAge, minPurchaseAge } = this.props;

    if (this.state.acknowledged || minRequiredAge == minPurchaseAge) {
      return false;
    }

    const today = moment();
    const { year, month, day } = this.props.selectedValues;
    const dob = moment([year, month, day]);
    const age = today.diff(dob, 'years');
    return age < minPurchaseAge;
  }

  onModalClose() {
    this.setState({ acknowledged: true });
  }

  render() {
    return (
      <div className="DobFieldGroup AddressForm__group">
        <div className="subhead navy">
          <TranslatedMessage id={m.DOB_TITLE} />
        </div>
        <p className="text flat-blue">
          <TranslatedMessage id={m.DOB_DESCRIPTION} />
        </p>

        {this.renderDateFields()}

        <DobWarningModal
          isOpen={this.shouldWarn()}
          onClose={this.onModalClose.bind(this)}
          age={this.props.minPurchaseAge}
        />
      </div>
    );
  }
}

export default DobFieldGroup;



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/DobFieldGroup.js